<template>
  <div class="block-chain-create">
    <common-bg-plate>
      <input-panel
        ref="basicInfo"
        :title="title1"
        :table-col="tableCol"
        :form="editForm"
        :rules="editRules"
      >
      </input-panel>
      <el-divider></el-divider>
      <detail-section :title="title2">
        <div class="consensus-section">
          <div class="labels">共识策略</div>
          <el-select v-model="form.Consensus" placeholder="请选择" @change="handleSelect">
            <el-option
              v-for="item in consensusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <dpos-linkage-box
          v-if="form.Consensus == 5"
          ref="dposLinkageBox"
          :algo-form="editForm"
          :consensus="form.Consensus"
          @update:node="
            val => {
              displayNodeList = val
            }
          "
          @change:disable="disabled = false"
        ></dpos-linkage-box>
        <linkage-box
          v-else
          ref="linkageBox"
          :consensus="form.Consensus"
          :algo-form="editForm"
          @update:node="
            val => {
              displayNodeList = val
            }
          "
          @change:disable="disabled = false"
        ></linkage-box>
      </detail-section>
      <el-divider></el-divider>
      <detail-section :title="title4">
        <!-- MAXBFT不支持SQL合约 -->
        <deploy-setting
          ref="deploySetting"
          :enable-contract-sql="form.Consensus != 3"
          :display-node-list="displayNodeList"
          @change:disable="disabled = false"
        ></deploy-setting>
      </detail-section>
      <el-divider></el-divider>
      <detail-section :title="title3" class="vm-type-section">
        <div class="labels">支持的虚拟机类型</div>
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            v-for="(item, i) in checkLabel"
            :key="item.value + i"
            :label="item.label"
            :value="item.value"
          >
          </el-checkbox>
        </el-checkbox-group>
        <div class="tips">
          默认支持WASMER、EVM、WXVM、GASM，支持Rust、Solidity、C++语言的合约；
          如果您想部署Go语言的合约或者您想为区块链部署预言机的话，需要勾选支持Docker_go，勾选后在部署链时除链的主程序外，还会再额外部署一个DockerVM；
        </div>
      </detail-section>
      <div class="btn-area">
        <el-button class="cancel" @click="handleCancel()">取消</el-button>
        <el-button type="primary" :disabled="disabled" :loading="loadingStatus" @click="handleOk()"
          >创建区块链</el-button
        >
        <el-button
          v-if="ChainIdCreated"
          class="downZip"
          type="primary"
          :disabled="disabled"
          :loading="loadingStatus"
          @click="downloadChain()"
          >下载部署包：{{ ChainIdCreated }}</el-button
        >
      </div>
    </common-bg-plate>
    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="下载部署包"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
    ></download-dialog>
  </div>
</template>

<script>
import inputPanel from './components/inputPanel'
import linkageBox from './components/linkageBox'
import dposLinkageBox from './components/dposLinkageBox'
import deploySetting from './components/deploySetting'
export default {
  name: 'CreateChain',
  components: {
    inputPanel,
    linkageBox,
    dposLinkageBox,
    deploySetting,
  },
  data() {
    let validateZero = (rule, value, callback) => {
      if (value === 0) {
        return callback(new Error('输入不能为0'))
      } else {
        callback()
      }
    }
    return {
      ChainIdCreated: '', //成功创建的最新chainId
      loadingStatus: false,
      disabled: false,
      title1: '基础信息',
      title2: '共识信息',
      title3: '合约虚拟机配置',
      title4: '节点部署配置',
      tableCol: [
        { label: '区块链ID', editType: 'input', bindValue: 'ChainId', width: '32%' },
        {
          label: '区块最大容量',
          editType: 'counter',
          counterUnit: '笔交易',
          bindValue: 'BlockTxCapacity',
          width: '32%'
        },
        {
          label: '出块间隔',
          editType: 'counter',
          counterUnit: 'ms',
          bindValue: 'BlockInterval',
          width: '32%'
        },
        { label: '区块链名称', editType: 'input', bindValue: 'ChainName', width: '32%' },
        {
          label: '交易最大延时',
          editType: 'counter',
          counterUnit: 's',
          bindValue: 'TxTimeout',
          width: '32%'
        },
        { label: '是否开启TLS', editType: 'switch', bindValue: 'Tls', width: '32%' },
        {
          label: '密码算法',
          editType: 'select',
          bindValue: 'Algorithm',
          width: '32%',
          options: [
            { label: '国密', value: 0 },
            { label: 'ECDSA', value: 1 },
            { label: 'IBC', value: 2 }
          ],
          handleSelect: val => {}
        },
        { label: '区块链简介', editType: 'input', bindValue: 'Summary', width: '32%' }
      ],
      showTips: false,
      tips: '',
      editForm: {
        BlockInterval: 2000,
        ChainName: '',
        ChainId: '',
        BlockTxCapacity: 100,
        TxTimeout: 600,
        Tls: true,
        Single: 1,
        Algorithm: 0,
        Summary: ''
      },
      form: {
        BlockInterval: 0,
        BlockTxCapacity: 0,
        ChainId: '',
        ChainName: '',
        ChainmakerImprove: 1, //默认
        Consensus: 0,
        DockerVm: 0,
        Monitor: 0, //默认
        Nodes: [],
        Tls: 0,
        TxTimeout: 0,
        Single: 1,
        Algorithm: 0,
        Summary: ''
      },
      editRules: {
        BlockInterval: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateZero, trigger: 'blur' }
        ],
        ChainName: [{ required: true, message: '请输入', trigger: 'blur' }],
        ChainId: [{ required: true, message: '请输入', trigger: 'blur' }],
        BlockTxCapacity: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateZero, trigger: 'blur' }
        ],
        TxTimeout: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateZero, trigger: 'blur' }
        ],
        Tls: [{ required: true, message: '请输入', trigger: 'blur' }],
        Single: [{ required: true, message: '请选择', trigger: 'blur' }],
        Summary: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      checkLabel: [
        { label: 'DOCKER_GO', value: 'DOCKER_GO' },
        { label: 'WASME', value: 'WASME' },
        { label: 'EVM', value: 'EVM' },
        { label: 'WXVM', value: 'WXVM' },
        { label: 'GASM', value: 'GASM' }
      ],
      checkList: ['GASM', 'WXVM', 'EVM', 'WASME'],
      selectNode: [],
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: '',
      displayNodeList: []
    }
  },
  computed: {
    consensusOptions: function() {
      let result = [
        { label: 'SOLO', value: 0, min: 1 },
        { label: 'TBFT', value: 1, min: 4 },
        { label: 'MAXBFT', value: 3, min: 4 },
        { label: 'RAFT', value: 4, min: 3 }
      ]
      //IBC密码算法，不支持DPos共识
      if (this.editForm.Algorithm != 2) {
        result.push({
          label: 'DPOS',
          value: 5,
          min: 4
        })
      }
      return result
    }
  },
  watch: {
    'form.Consensus': function(val, oldVal) {
      //form.Consensus切换为5即DPOS共识，或从DPOS共识变为其他，要清空节点列表
      if ((val == 5 || oldVal == 5) && val != oldVal) {
        this.displayNodeList = []
      }
    }
  },
  mounted() {},
  methods: {
    formatIp(row, type) {
      if (row) {
        let val = (row.addr || '').split(':')
        if (type === 'ip') {
          return val[0]
        } else {
          return val[1]
        }
      }
    },
    async handleOk() {
      this.disabled = true
      //合约虚拟机配置
      let flag = this.checkList.includes('DOCKER_GO')
      this.form.DockerVm = flag ? 1 : 0
      //共识信息
      let nodes = await this.handleNode()
      if (nodes) {
        //DPOS共识，提交的表单数据
        if (nodes.dpos) {
          this.form.DposAdminID = nodes.DposAdminID
          this.form.DposNodes = nodes.DposNodes
          this.form.Single = this.$refs.deploySetting.getSingle()
        } else {
          this.form.Nodes = nodes
          this.form.Single = this.$refs.deploySetting.getSingle()
        }
      } else {
        this.disabled = false
        return
      }
      //基础信息
      this.$refs.basicInfo.$refs.editForm.validate(valid => {
        if (valid) {
          this.loadingStatus = true
          let info = this.$refs.basicInfo.getForm()
          let keys = Object.keys(this.editForm)
          keys.map(ele => {
            if (ele === 'Tls') {
              this.form.Tls = info[ele] ? 0 : 1
            } else {
              this.form[ele] = info[ele]
            }
          })
          this.$apis.chain
            .createChain(this.form)
            .then(res => {
              if (!res.errors) {
                this.ChainIdCreated = this.form.ChainId
                this.loadingStatus = false
              } else {
                this.loadingStatus = false
                this.$message.warning('创建 chain 没有成功，res.errors=' + res.errors)
              }
              this.disabled = false
            })
            .catch(err => {
              this.$message.warning('创建 chain 错误: ' + err.message)
              this.disabled = false
              this.loadingStatus = false
            })
        } else {
          this.loadingStatus = false
          this.disabled = false
          this.$message.warning('请完善信息')
        }
      })
    },
    downloadChain() {
      this.downloadUrl = `/cbaas-service/v1/chainManagement/downloadChain?chainId=${this.form.ChainId}`;
      this.downloadFileName = `${this.form.ChainId}_Package_部署包.zip`;
      this.showDownloadDialog = true
      this.loadingStatus = false  
    },
    handleNode() {
      return new Promise((resolve, reject) => {
        //DPOS共识算法从dposLinkageBox获取值
        if (this.form.Consensus == 5) {
          let selectStatus = this.$refs.dposLinkageBox.getData()
          let nodeStatus = this.$refs.deploySetting.getData()
          if (selectStatus && nodeStatus) {
            let list = []
            list = selectStatus.DposNodes.map(ele => {
              let searchItem = nodeStatus.filter(items => items.NodeName === ele.NodeName)
              return {
                NodeID: ele.NodeID,
                NodeName: ele.NodeName,
                SqlDbDsn: searchItem[0]?.SqlDbDsn,
                NodeIP: searchItem[0]?.NodeIp,
                NodeRpcPort: searchItem[0]?.NodeRpcPort,
                NodeP2pPort: searchItem[0]?.NodeP2pPort
              }
            })
            selectStatus.DposNodes = list
            selectStatus.dpos = true
            resolve(selectStatus)
          } else {
            return
          }
        } else {
          let selectStatus = this.$refs.linkageBox.getData()
          let nodeStatus = this.$refs.deploySetting.getData()
          if (selectStatus && nodeStatus) {
            let list = []
            selectStatus.map(ele => {
              let item = {
                OrgId: ele.OrgId,
                NodeList: []
              }
              ele.nodeList.map(elem => {
                let searchItem = nodeStatus.filter(items => items.NodeName === elem.NodeName)
                item.NodeList.push(searchItem[0])
              })
              list.push(item)
            })
            resolve(list)
          } else {
            return
          }
        }
      })
    },
    handleCancel() {
      this.form = {
        BlockInterval: 0,
        BlockTxCapacity: 0,
        ChainId: '',
        ChainName: '',
        ChainmakerImprove: 1, //默认
        Consensus: 0,
        DockerVm: 0,
        Monitor: 0, //默认
        Nodes: [],
        Tls: 0,
        TxTimeout: 0,
        Single: 0,
        Summary: ''
      }
      this.$refs.basicInfo.$refs.editForm.clearValidate()
      this.$router.go(-1)
    },
    handleSelect(val) {}
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-create',
  (
    --block-chain-create-vm-type-section-tips-color: #a3afb5,
    --block-chain-create-section-labels-color: #fff
  ),
  (
    --block-chain-create-vm-type-section-tips-color: #5a6973,
    --block-chain-create-section-labels-color: #192227
  )
);
.block-chain-create {
  @include adaptation(
    (
      --block-chain-create-section-font-size: 12px,
      --block-chain-create-section-labels-height: 17px,
      --block-chain-create-section-labels-margin-bottom: 8px,
      --block-chain-create-vm-type-section-checkbox-group-height: 17px,
      --block-chain-create-vm-type-section-checkbox-group-margin-bottom: 8px,
      --block-chain-create-vm-type-section-tips-width: 523px,
      --block-chain-create-btn-area-padding: 16px 16px 32px,
      --block-chain-create-btn-area-item-margin-left: 16px,
      --block-chain-create-consensus-section-select-width: 246px,
      --block-chain-create-consensus-section-select-margin-bottom: 20px
    )
  );

  .el-divider {
    margin: 0;
  }

  .consensus-section {
    font-size: var(--block-chain-create-section-font-size);

    .labels {
      height: var(--block-chain-create-section-labels-height);
      line-height: var(--block-chain-create-section-labels-height);
      color: var(--block-chain-create-section-labels-color);
      margin-bottom: var(--block-chain-create-section-labels-margin-bottom);
    }

    .el-select {
      width: var(--block-chain-create-consensus-section-select-width);
      margin-bottom: var(--block-chain-create-consensus-section-select-margin-bottom);
    }
  }

  .vm-type-section {
    font-size: var(--block-chain-create-section-font-size);
    .labels {
      height: var(--block-chain-create-section-labels-height);
      line-height: var(--block-chain-create-section-labels-height);
      color: var(--block-chain-create-section-labels-color);
      margin-bottom: var(--block-chain-create-section-labels-margin-bottom);
    }
    .el-checkbox-group {
      height: var(--block-chain-create-vm-type-section-checkbox-group-height);
      display: flex;
      margin-bottom: var(--block-chain-create-vm-type-section-checkbox-group-margin-bottom);
    }
    .tips {
      width: var(--block-chain-create-vm-type-section-tips-width);
      color: var(--block-chain-create-vm-type-section-tips-color);
      font-size: var(--block-chain-create-section-font-size);
      line-height: var(--block-chain-create-section-labels-height);
    }
  }

  .btn-area {
    padding: var(--block-chain-create-btn-area-padding);
    display: flex;
    justify-content: center;

    .el-button {
      &:not(:first-child) {
        margin-left: var(--block-chain-create-btn-area-item-margin-left);
      }
    }
  }
}
</style>
